export default __webpack_public_path__ + "c223eb668758573f5e714ec8d4d292ef.wasm";